import React from "react";
import {Box, Button, Container, Dialog, DialogActions, DialogContent, Stack, Typography} from "@mui/material";
import {formatDateISO} from "../../../utils/helpers";

export default function ContractsDialog({open, onClose, contracts, onGenerateContract, onSendLastContract}) {
    if (!contracts) return null;

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogContent>
                <Typography variant="h6">Contrats de location</Typography>
                <Typography variant="body1" sx={{mb: 2}}>
                    Retrouvez ici l'historique des contrats générés pour cette réservation.
                </Typography>
                <Container disableGutters={true}>
                    {contracts.sort((a, b) => b.version - a.version).map((contract) => (
                        <React.Fragment key={contract.id}>
                            {contract.is_signed && (
                                <Stack className="contracts-list-item" onClick={() => onGenerateContract(contract.version, true)}>
                                    <Box className="contract-version">{contract.version}</Box>
                                    <Box className="contract-infos">
                                        <Typography className="contract-title">Contrat n°{contract.version} signé</Typography>
                                        <Typography className="contract-date">{formatDateISO(contract.signed_at)}</Typography>
                                    </Box>
                                </Stack>
                            )}
                            <Stack className="contracts-list-item" onClick={() => onGenerateContract(contract.version)}>
                                <Box className="contract-version">{contract.version}</Box>
                                <Box className="contract-infos">
                                    <Typography className="contract-title">Contrat n°{contract.version}</Typography>
                                    <Typography className="contract-date">{formatDateISO(contract.created_at)}</Typography>
                                </Box>
                            </Stack>
                        </React.Fragment>
                    ))}
                </Container>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fermer</Button>
                <Button variant="contained" onClick={onSendLastContract}>Envoyer le dernier contrat par mail</Button>
            </DialogActions>
        </Dialog>
    );
}
